export default __webpack_public_path__ + "static/media/ic_bondprotocol_arbitrum.7aaf0874.svg";